import { Language } from 'js/vue/stores/languages/languagesStore';

const getLanguageIcon = (language: Language): string => {
    return `/ressources/public/img/flags/${language.flag ?? 'blank'}.png`;
};

export { getLanguageIcon };
